module.exports = __webpack_public_path__ + "img/73_10.cb280323.png";